// /admin/vendors — organizations as vendors: profile (cid, contact, IBAN, notifications, delivery days) + members.
import { lazyRoute } from "aldoo-ra/Router/lazy-route"
import { vendorRole } from "../AdminShared/vendor-role"

export default {
  "/admin/vendors*": lazyRoute(() => import("./index"), vendorRole),
}
